import { gql } from '@apollo/client';

import {
  PAID_SERVICE_OPTION_FIELDS,
  PAID_SERVICE_PAYMENT_METHODS_FIELDS
} from './fields';

export const GET_PAID_SERVICES = gql`
  ${PAID_SERVICE_OPTION_FIELDS}
  ${PAID_SERVICE_PAYMENT_METHODS_FIELDS}
  query paidServices($targetType: PaidServiceTargetTypeEnum!, $targetId: ID) {
    paidServices(targetType: $targetType, targetId: $targetId) {
      description
      id
      targetType
      title
      options {
        ...PaidServiceOptionFields
      }
      paymentMethods {
        ...PaidServicePaymentMethodsFields
      }
    }
  }
`;

export const GET_PAYMENT_INFO = gql`
  query GetPayment($signedId: String!) {
    payment(signedId: $signedId) {
      id
      amount
      targetId
      targetType
      message
      success
      finished
      serviceName
      serviceId
      updatedAt
      returnTo
      source
    }
  }
`;
